{
  "localSettings": {
    "ancillaries": {
      "productCard": {
        "originalPriceLabel": "Alkuperäinen hinta"
      }
    }
  },
  "ancillaries": {
    "perBooking": "/ varaus",
    "seats": {
      "activePassengerChanged": "Valitset nyt paikkaa matkustajalle {name}"
    },
    "bundle": {
      "conflictingBundle": "",
      "serviceIncludedInBundleNotification": "",
      "upsellCard": {
        "seatWifi": {
          "buttonText": {
            "addCombo": "Add combo",
            "added": "Added"
          },
          "addCombo": {
            "productCardTitle": "Seat + {productName}",
            "title": "10% off when booked together",
            "image": {
              "alt": "",
              "contentId": 3560630,
              "data": "https://cms.finnair.com/resource/blob/3560630/80aa2cea7e79a9379824866463d55f13/stream-full-flight-data.jpg",
              "teaserTitle": "",
              "responsiveImageLinksData": {
                "landscape_ratio21x9": {
                  "768": "https://cms.finnair.com/resource/blob/3560630/80aa2cea7e79a9379824866463d55f13/stream-full-flight-data.jpg?impolicy=crop&width=4000&height=1714&x=0&y=791"
                },
                "landscape_ratio16x9": {
                  "768": "https://cms.finnair.com/resource/blob/3560630/80aa2cea7e79a9379824866463d55f13/stream-full-flight-data.jpg?impolicy=crop&width=4000&height=2250&x=0&y=278"
                },
                "portrait_ratio1x1": {
                  "768": "https://cms.finnair.com/resource/blob/3560630/80aa2cea7e79a9379824866463d55f13/stream-full-flight-data.jpg?impolicy=crop&width=2666&height=2666&x=681&y=0"
                },
                "landscape_ratio4x3": {
                  "768": "https://cms.finnair.com/resource/blob/3560630/80aa2cea7e79a9379824866463d55f13/stream-full-flight-data.jpg?impolicy=crop&width=3555&height=2666&x=445&y=0"
                }
              }
            }
          },
          "addProduct": {
            "title": "Get internet for less withn a seat",
            "image": {
              "alt": "",
              "contentId": 3560630,
              "data": "https://cms.finnair.com/resource/blob/3560630/80aa2cea7e79a9379824866463d55f13/stream-full-flight-data.jpg",
              "teaserTitle": "",
              "responsiveImageLinksData": {
                "landscape_ratio21x9": {
                  "768": "https://cms.finnair.com/resource/blob/3560630/80aa2cea7e79a9379824866463d55f13/stream-full-flight-data.jpg?impolicy=crop&width=4000&height=1714&x=0&y=791"
                },
                "landscape_ratio16x9": {
                  "768": "https://cms.finnair.com/resource/blob/3560630/80aa2cea7e79a9379824866463d55f13/stream-full-flight-data.jpg?impolicy=crop&width=4000&height=2250&x=0&y=278"
                },
                "portrait_ratio1x1": {
                  "768": "https://cms.finnair.com/resource/blob/3560630/80aa2cea7e79a9379824866463d55f13/stream-full-flight-data.jpg?impolicy=crop&width=2666&height=2666&x=681&y=0"
                },
                "landscape_ratio4x3": {
                  "768": "https://cms.finnair.com/resource/blob/3560630/80aa2cea7e79a9379824866463d55f13/stream-full-flight-data.jpg?impolicy=crop&width=3555&height=2666&x=445&y=0"
                }
              }
            }
          }
        }
      },
      "toggle": {
        "personalized": {
          "comboOfferText": "Personoitu kombo"
        }
      },
      "bundlePriceLabel": "Paketin hinta",
      "discountLabel": "{percentage}% alennus",
      "serviceCard": {
        "inCartTag": "Ostoskorissa",
        "tierBenefitTag": "Jäsenetu"
      },
      "quota": {
        "enoughForAll": {
          "title": {
            "singular": "Vain yksi kombo jäljellä",
            "plural": "Vain {amount} komboa jäljellä"
          },
          "description": "Lisää omasi ennen kuin ne loppuvat."
        },
        "allSelected": {
          "title": "Ei yhtään komboa jäljellä",
          "description": "Olet lisännyt kombon kaikille varauksessasi."
        },
        "shortForGroup": {
          "title": {
            "singular": "Vain yksi kombo jäljellä {passengerCount} hengen ryhmällesi",
            "plural": "Vain {amount} komboa jäljellä {passengerCount} hengen ryhmällesi"
          },
          "description": "Saatavuus on tällä lennolla rajattu.",
          "noneLeft": "Tälle lennolle ei ole enää komboja jäljellä."
        },
        "takenByOtherPassenger": "Lisäsit viimeisen jäljellä olleen kombon toiselle matkustajalle."
      }
    },
    "ancillaryCombos": {
      "eligibility": {
        "boundFlown": "Tämä lento on jo lähtenyt.",
        "notAvailableBus": "Valitettavasti <b>matkasi tälle osuudelle ei voi ostaa komboa</b>, koska tämä on bussiyhteys.",
        "notAvailableTrain": "Valitettavasti <b>matkasi tälle osuudelle ei voi ostaa komboa</b>, koska tämä on junayhteys."
      },
      "noAncillaryCombosAvailable": "Komboja ei ole saatavilla matkasi tälle osuudelle.",
      "noAncillaryCombosAvailableBus": "Valitettavasti <b>matkasi tälle osuudelle ei voi ostaa komboa</b>, koska tämä on bussiyhteys.",
      "noAncillaryCombosAvailableForOperatingAirline": "Komboja ei ole saatavilla tälle lennolle"
    },
    "seatMeal": {
      "quota": {
        "enoughForAll": {
          "title": {
            "singular": "Vain yksi Istuinpaikka + Ateria-kombo jäljellä",
            "plural": "Vain {amount} Istuinpaikka + Ateria-komboa jäljellä"
          },
          "description": "Lisää omasi ennen kuin ennakkotilattavat ateriat loppuvat."
        },
        "allSelected": {
          "title": "Ei yhtään Istuinpaikka + Ateria-komboa jäljellä",
          "description": "Olet lisännyt Istuinpaikka + Ateria-kombon kaikille varauksessasi."
        },
        "shortForGroup": {
          "title": {
            "singular": "Vain yksi Istuinpaikka + Ateria-kombo jäljellä {passengerCount} hengen ryhmällesi",
            "plural": "Vain {amount} Istuinpaikka + Ateria-komboa jäljellä {passengerCount} hengen ryhmällesi"
          },
          "description": "Ennakkotilattavia aterioita on tällä lennolla rajoitetusti.",
          "noneLeft": "Istuinpaikka + Ateria -kombon ennakkotilattavat ateriat on myyty loppuun tältä lennolta."
        },
        "takenByOtherPassenger": "Lisäsit viimeisen jäljellä olleen Istuinpaikka + Ateria-kombon toiselle matkustajalle.",
        "quotaReached": "Tähän komboon kuuluvat ennakkotilattavat ateriat on myyty loppuun tältä lennolta."
      }
    },
    "wifiMeal": {
      "quota": {
        "enoughForAll": {
          "title": {
            "singular": "Vain yksi Internet + Ateria-kombo jäljellä",
            "plural": "Vain {amount} Internet + Ateria-komboa jäljellä"
          },
          "description": "Lisää omasi ennen kuin ennakkotilattavat ateriat loppuvat."
        },
        "allSelected": {
          "title": "Ei yhtään Internet + Ateria-komboa jäljellä",
          "description": "Olet lisännyt Internet + Ateria-kombon kaikille varauksessasi."
        },
        "shortForGroup": {
          "title": {
            "singular": "Vain yksi Internet + Ateria-kombo jäljellä {passengerCount} hengen ryhmällesi",
            "plural": "Vain {amount} Internet + Ateria-komboa jäljellä {passengerCount} hengen ryhmällesi"
          },
          "description": "Ennakkotilattavia aterioita on tällä lennolla rajoitetusti.",
          "noneLeft": "Internet + Ateria -kombon ennakkotilattavat ateriat on myyty loppuun tältä lennolta."
        },
        "takenByOtherPassenger": "Lisäsit viimeisen jäljellä olleen Internet + Ateria-kombon toiselle matkustajalle.",
        "quotaReached": "Tähän komboon kuuluvat ennakkotilattavat ateriat on myyty loppuun tältä lennolta."
      }
    },
    "seatPriority": {
      "quota": {
        "enoughForAll": {
          "title": {
            "singular": "Vain yksi Istuinpaikka + Priority-kombo jäljellä",
            "plural": "Vain {amount} Istuinpaikka + Priority-komboa jäljellä"
          },
          "description": "Lisää omasi ennen kuin priority-palvelut loppuvat."
        },
        "allSelected": {
          "title": "Ei yhtään Istuinpaikka + Priority-komboa jäljellä",
          "description": "Olet lisännyt Istuinpaikka + Priority-kombon kaikille varauksessasi."
        },
        "shortForGroup": {
          "title": {
            "singular": "Vain yksi Istuinpaikka + Priority-kombo jäljellä {passengerCount} hengen ryhmällesi",
            "plural": "Vain {amount} Istuinpaikka + Priority-komboa jäljellä {passengerCount} hengen ryhmällesi"
          },
          "description": "Priority-palveluita on tällä lennolla rajoitetusti.",
          "noneLeft": "Istuinpaikka + Priority -kombon priority-palvelut on myyty loppuun tältä lennolta."
        },
        "takenByOtherPassenger": "Lisäsit viimeisen jäljellä olleen Istuinpaikka + Priority-kombon toiselle matkustajalle.",
        "quotaReached": "Tähän komboon kuuluvat priority-palvelut on myyty loppuun tältä lennolta."
      }
    },
    "loungePriority": {
      "quota": {
        "enoughForAll": {
          "title": {
            "singular": "Vain yksi Lounge + Priority-kombo jäljellä",
            "plural": "Vain {amount} Lounge + Priority-komboa jäljellä"
          },
          "description": "Lisää omasi ennen kuin priority-palvelut loppuvat."
        },
        "allSelected": {
          "title": "Ei yhtään Lounge + Priority-komboa jäljellä",
          "description": "Olet lisännyt Lounge + Priority-kombon kaikille varauksessasi."
        },
        "shortForGroup": {
          "title": {
            "singular": "Vain yksi Lounge + Priority-kombo jäljellä {passengerCount} hengen ryhmällesi",
            "plural": "Vain {amount} Lounge + Priority-komboa jäljellä {passengerCount} hengen ryhmällesi"
          },
          "description": "Priority-palveluita on tällä lennolla rajoitetusti.",
          "noneLeft": "Lounge + Priority -kombon priority-palvelut on myyty loppuun tältä lennolta."
        },
        "takenByOtherPassenger": "Lisäsit viimeisen jäljellä olleen Lounge + Priority-kombon toiselle matkustajalle.",
        "quotaReached": "Tähän komboon kuuluvat priority-palvelut on myyty loppuun tältä lennolta."
      }
    }
  },
  "shoppingCart": {
    "addedTravelExtras": "Lisätyt lisäpalvelut",
    "allFlights": "Kaikki lennot",
    "included": "Sisältyy",
    "partnerFlightNotification": {
      "singular": "Lennon {routes} liikennöi kumppanimme. Tarkista saatavilla olevat lisäpalvelut ja tarkat matkatavarasäännöt heidän verkkosivuiltaan.",
      "plural": "Lennot {routes} liikennöivät kumppanimme. Tarkista saatavilla olevat lisäpalvelut ja tarkat matkatavarasäännöt heidän verkkosivuiltaan."
    }
  },
  "paxDetails": {
    "reviewTitle": {
      "single": "Review passenger details",
      "multi": "Review and add details"
    }
  },
  "purchase": {
    "success": {
      "stayInTouch": {
        "default": {
          "title": "Lähetämme sinulle viestejä matkalle valmistautumisesta",
          "description": "<p>Saat muistutuksia, vinkkejä ja tarjouksia liittyen tuleviin matkoihisi sähköpostilla.</p><p>Voit muokata viestintäasetuksiasi milloin tahansa <a href='https://www.finnair.com/fi-fi/my-finnair-plus/update-profile?section=marketing-preferences' target='_blank' rel='noopener noreferrer'>Finnair Plus -profiilissasi</a>.</p>"
        },
        "multiPassenger": {
          "title": "Lähetämme sinulle viestejä matkalle valmistautumisesta",
          "description": "<p>Saat muistutuksia, vinkkejä ja tarjouksia liittyen tuleviin matkoihisi sähköpostilla. Myös muut varauksen matkustajat saattavat saada viestejä heidän viestintäasetustensa mukaisesti.</p><p>Voit muokata asetuksiasi milloin tahansa <a href='https://www.finnair.com/fi-fi/my-finnair-plus/update-profile?section=marketing-preferences' target='_blank' rel='noopener noreferrer'>Finnair Plus -profiilissasi</a>.</p>"
        },
        "emailMismatch": {
          "title": "Lähetämme sinulle viestejä matkalle valmistautumisesta",
          "description": "<p>Saat muistutuksia, vinkkejä ja tarjouksia liittyen tuleviin matkoihisi varauksessa käyttämääsi sähköpostiosoitteeseen: {email}</p><p>Voit muokata viestintäasetuksiasi sähköpostin alaosassa olevasta linkistä.</p>"
        },
        "multiPassengerEmailMismatch": {
          "title": "Lähetämme sinulle viestejä matkalle valmistautumisesta",
          "description": "<p>Saat muistutuksia, vinkkejä ja tarjouksia liittyen tuleviin matkoihisi varauksessa käyttämääsi sähköpostiosoitteeseen: {email}. Myös muut varauksen matkustajat saattavat saada viestejä heidän viestintäasetustensa mukaisesti.</p><p>Voit muokata viestintäasetuksiasi sähköpostin alaosassa olevasta linkistä.</p>"
        }
      }
    }
  }
}
